import * as Yup from "yup";
import { MapFleetFiltersData } from "../map-fleet/ModalMapFleetFilters";
import { APP_CONFIG } from "../../constants/constants";
import { phoneRegex } from "../../utils/validation";

export const formInitialValues = {
  address: "",
  traffic: false,
  weather: false,
  street_view: false,
  three_d_building: false,
  attribute_filtering: "",
  spatial_filtering: "",
  temporal_filtering: "",
  hide_geozones: false,
  clustering: false,
  date: "",
  time: "",
  timezone: "",
  auto_refresh_timer: "",
};

export const dateInitialValues: MapFleetFiltersData = {
  date_time: new Date().toISOString(),
  timezone: APP_CONFIG.DEFAULT_TIMEZONE,
  calculatedUnixTimestamp: Date.now(),
};

export const dateValidationSchema = Yup.object().shape({});

export const YupValidationSchema = Yup.object().shape({});

export const layerFilterInitialValues = {
  view: "road",
  traffic: false,
  weather: false,
  three_d_building: false,
  clustering: true,
  hide_geozones: false,
};
export const LayerFilterValidationSchema = Yup.object().shape({});

// form field names
export type TFormFieldNames = "phone" | "message";
export const sendTextFormInitialValues = {
  phone: "",
  message: "",
};

export const sendLocationFormInitialValues = {
  phone: "",
};

export const SendLocationValidationSchema = Yup.object().shape({
  phone: Yup.string()
    .matches(phoneRegex, "Invalid phone")
    .required("Phone is required"),
});
